import { toast } from 'sonner';
import { CopyIcon, DownloadIcon } from 'lucide-react';
import { btnSecondary } from '../ui/styles';
type Props = {
  codes: string[];
};
const fileText = (codes: string[]) => ['Beauty Bewust beheer: herstelcodes', 'Elke code werkt één keer. Bewaar dit op een veilige plek, niet op je telefoon.', '', ...codes, ''].join('\n');

/** De herstelcodes, één keer zichtbaar: kopiëren of als bestand bewaren. */
export function RecoveryCodes({
  codes
}: Props) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(codes.join('\n'));
      toast.success('Herstelcodes gekopieerd');
    } catch {
      toast.error('Kopiëren lukte niet', {
        description: 'Download ze als bestand, of schrijf ze over.'
      });
    }
  };
  const download = () => {
    const url = URL.createObjectURL(new Blob([fileText(codes)], {
      type: 'text/plain;charset=utf-8'
    }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'beauty-bewust-herstelcodes.txt';
    a.click();
    URL.revokeObjectURL(url);
  };
  return <div data-id="element-3866" data-mp="acy1sjoqmlyb">
      <ul className="grid grid-cols-2 gap-x-6 gap-y-2 rounded-md border border-line bg-shell px-4 py-4 font-mono text-[14px] text-ink" aria-label="Herstelcodes" data-id="element-3867" data-mp="acofp76tcyxw">
        {codes.map(c => <li key={c} data-id="element-3868" data-mp="ipcs5yx1b4w">{c}</li>)}
      </ul>
      <div className="mt-3 flex flex-wrap gap-2" data-id="element-3869" data-mp="3rqbp0mzpalxd">
        <button type="button" onClick={() => void copy()} className={btnSecondary} data-id="element-3870" data-mp="3rpinq1jigomm">
          <CopyIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-3871" data-mp="3mq5r4p2u836u" />
          Kopiëren
        </button>
        <button type="button" onClick={download} className={btnSecondary} data-id="element-3872" data-mp="3it1bsw3bompt">
          <DownloadIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-3873" data-mp="3dru5l1gtvvl9" />
          Download als bestand
        </button>
      </div>
    </div>;
}